import { Transformation } from '@diritto/common/imageKit/transformation';

export enum ImageTransformType {
  Original = 'Original',
  Profile = 'Profile',
  CoverEditorBg = 'CoverEditorBg',
  FancyShare = 'FancyShare',
  Inbox = 'Inbox',
  ContentCover = 'ContentCover',
  OG = 'OG',
  Icon = 'Icon',
  Banner = `Banner`,
  CustomQuickMenu = `CustomQuickMenu`,
}

export const ImageTransformOptions = {
  [ImageTransformType.Original]: { original: true } as Transformation,
  [ImageTransformType.Profile]: { width: 200 } as Transformation,
  [ImageTransformType.CoverEditorBg]: { width: 600 } as Transformation,
  [ImageTransformType.FancyShare]: { quality: 85, width: 800 } as Transformation,
  [ImageTransformType.Inbox]: { quality: 85, width: 200 } as Transformation,
  [ImageTransformType.ContentCover]: { quality: 85, width: 200 } as Transformation,
  [ImageTransformType.OG]: { quality: 85, width: 500, format: 'jpg' } as Transformation,
  [ImageTransformType.Banner]: { quality: 85, width: 700 } as Transformation,
  [ImageTransformType.CustomQuickMenu]: { quality: 85, width: 700 } as Transformation,
  [ImageTransformType.Icon]: { quality: 85, width: 96 } as Transformation,
};
